import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-health-care-workflow',
  imports: [CommonModule, TranslateModule],
  templateUrl: './health-care-workflow.component.html',
  styleUrl: './health-care-workflow.component.scss',
})
export class HealthCareWorkflowComponent {}
